import { render, staticRenderFns } from "./TipoLeilao.vue?vue&type=template&id=124fe5dc&"
import script from "./TipoLeilao.vue?vue&type=script&lang=js&"
export * from "./TipoLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports